import React from 'react';
import { Link, Route, Switch, useHistory, Redirect, useLocation } from 'react-router-dom';
import * as routes from '../../../constants/routes';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Profile from './profile/Profile';
import Account from './account/Account';
import Financial from './financial/Financial';
import { SETTINGS_PROFILE ,TERMS_PRIVACY ,SETTINGS_ACCOUNT,PROFILE} from '../../../constants/routes';

import HelpSupport from './HelpSupport';
import { ArrowLeftIcon, CoinsIcon, HelpIcon, ProfileIcon, WalletIcon, MenuArrow } from '../../../components/Icons';
import { selectAuthUser, selectCreditCards, selectIsAuthorizing } from '../../../reducers/auth/auth.selectors';

const MenuSettings = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const user = useSelector(selectAuthUser);

    return (
        <div className="settings-cont ">
            <div className="menu-user-nickname">
                <p>@{user.nickname}</p>
            </div>
            <hr/>
            <div className="menu-settings-side-menu">
                <ul className="">
                    <li className="menu-list-group-item ">
                        <Link
                            to={PROFILE}
                        >
                            {t('channel')}
                            <MenuArrow />
                        </Link>
                    </li>
                    <li className="menu-list-group-item  ">
                        <Link

                            to={SETTINGS_ACCOUNT}
                        >

                            {t('account')}
                            <MenuArrow />
                        </Link>
                    </li>
                    <li className="menu-list-group-item  ">
                        <Link

                            to={TERMS_PRIVACY}
                        >

                            {t('privacy and safety')}
                            <MenuArrow />
                        </Link>
                    </li>
                    

                </ul>
            </div>
            <hr/>


        </div>
    );
};

export default MenuSettings;
